import Artists from './artists'

export default Artists
